import {ReactNode} from "react";
import {
  addRoleMemberDialog,
  addTeamMemberDialog,
  confirmationDialog,
  createEditTeamDialog,
  inviteUserDialog,
  reassignTeamDialog,
  reassignUserDialog,
  signOutDialog,
} from ".";
import {provideDialog} from "../../components/dialogs";
import {DialogProvider} from "../../components/dialogs/DialogProvider";
import ConfirmationDialog from "./ConfirmationDialog";
import ReassignTeamDialog from "./ReassignTeamDialog";
import ReassignUserDialog from "./ReassignUserDialog";
import {InviteUserDialog} from "./InviteUserDialog";
import {CreateEditTeamDialog} from "./CreateEditTeamDialog";
import AddRoleMemberDialog from "./AddRoleMemberDialog";
import AddTeamMemberDialog from "./AddTeamMemberDialog";
import SignOutDialog from "./SignOutDialog";

const AppDialogProvider = ({children}: {children: ReactNode}) => {
  return (
    <DialogProvider
      dialogs={[
        provideDialog(confirmationDialog, props => <ConfirmationDialog {...props} />),
        provideDialog(reassignUserDialog, props => <ReassignUserDialog {...props} />),
        provideDialog(reassignTeamDialog, props => <ReassignTeamDialog {...props} />),
        provideDialog(inviteUserDialog, props => <InviteUserDialog {...props} />),
        provideDialog(createEditTeamDialog, props => <CreateEditTeamDialog {...props} />),
        provideDialog(addRoleMemberDialog, props => <AddRoleMemberDialog {...props} />),
        provideDialog(addTeamMemberDialog, props => <AddTeamMemberDialog {...props} />),
        provideDialog(signOutDialog, props => <SignOutDialog {...props} />),
      ]}
    >
      {children}
    </DialogProvider>
  );
};

export default AppDialogProvider;
